import React from 'react';
import {
  Show as RaShow,
  Tab,
  TextField,
  DateField,
  FunctionField,
  TabbedShowLayout,
  SimpleShowLayout,
  ImageField,
  BooleanField,
} from 'react-admin';
import { DataGrid } from '@mui/x-data-grid';

import { TextFieldWithCopy } from '../../components/TextFieldWithCopy';
import { usePageTitle } from '../../components/usePageTitle';
import { useStyles } from './styles';

export const Show = (props) => {
  usePageTitle(props);
  const classes = useStyles();
  const columns = [
    { field: 'id', headerName: 'ID', sortable: false },
    { field: 'amount_total', headerName: 'Amount total', sortable: false },
    {
      field: 'user_account_id',
      headerName: 'User account id',
      sortable: false,
    },
    { field: 'status', headerName: 'Status', sortable: false },
    { field: 'type', headerName: 'Type', sortable: false },
    { field: 'status', headerName: 'Status', sortable: false },
    { field: 'account_iban', headerName: 'Account IBAN', sortable: false },
    { field: 'target_card_id', headerName: 'Target card ID', sortable: false },
    { field: 'card_id', headerName: 'Card ID', sortable: false },
    { field: 'card_mask', headerName: 'Card mask', sortable: false },
    { field: 'card_description', headerName: 'Account IBAN', sortable: false },
    { field: 'currency_id', headerName: 'Currency ID', sortable: false },
    { field: 'tax', headerName: 'Tax', sortable: false },
    { field: 'amount', headerName: 'Amount', sortable: false },
    { field: 'penalty_amount', headerName: 'Penalty amount', sortable: false },
    { field: 'amount_default', headerName: 'Default amount', sortable: false },
    { field: 'old_balance', headerName: 'Old balance', sortable: false },
    { field: 'new_balance', headerName: 'New balance', sortable: false },
    { field: 'description', headerName: 'Description', sortable: false },
    { field: 'comment', headerName: 'Comment', sortable: false },
    { field: 'type_enum', headerName: 'Type enum', sortable: false },
    { field: 'country', headerName: 'Country', sortable: false },
    { field: 'status_text', headerName: 'Status text', sortable: false },
    { field: 'custom_status', headerName: 'Custom status', sortable: false },
    {
      field: 'money_request_id',
      headerName: 'Money request id',
      sortable: false,
    },
    {
      field: 'amount_original',
      headerName: 'Amount original',
      sortable: false,
    },
    {
      field: 'currency_code_original',
      headerName: 'Currency code original',
      sortable: false,
    },
  ];

  return (
    <>
      <RaShow {...props}>
        <SimpleShowLayout>
          <TabbedShowLayout className={classes.tabContainer}>
            <Tab label="general">
              <SimpleShowLayout className={classes.formContainer}>
                <SimpleShowLayout className={classes.formColumnContainer}>
                  <TextFieldWithCopy source="id" />
                  <TextField
                    emptyText="No data"
                    source="amount_total"
                    label="Total amount"
                  />
                  <TextFieldWithCopy
                    source="user_account_id"
                    label="User account ID"
                  />
                  <TextField
                    emptyText="No data"
                    source="status"
                    label="Status"
                  />
                  <TextField emptyText="No data" source="type" label="Type" />
                  <TextFieldWithCopy
                    source="account_iban"
                    label="Account IBAN"
                  />
                  <TextField
                    emptyText="No data"
                    source="target_card_id"
                    label="Target card ID"
                  />
                  <TextFieldWithCopy source="card_id" label="Card ID" />
                  <TextFieldWithCopy source="card_mask" label="Card mask" />
                  <TextField
                    emptyText="No data"
                    source="card_description"
                    label="Card daescription"
                  />
                  <TextFieldWithCopy source="currency_id" label="Currency ID" />
                  <TextField emptyText="No data" source="tax" label="Tax" />
                  <TextField
                    emptyText="No data"
                    source="amount"
                    label="Amount"
                  />
                  <TextField
                    emptyText="No data"
                    source="penalty_amount"
                    label="Penalty amount"
                  />
                  <TextField
                    emptyText="No data"
                    source="amount_default"
                    label="Default amount"
                  />
                  <TextField
                    emptyText="No data"
                    source="old_balance"
                    label="Old balance"
                  />
                  <TextField
                    emptyText="No data"
                    source="new_balance"
                    label="New baalance"
                  />
                  <TextField
                    emptyText="No data"
                    source="description"
                    label="Description"
                  />
                  <TextField
                    emptyText="No data"
                    source="comment"
                    label="Comment"
                  />
                  <FunctionField
                    source="merchant"
                    label="Merchant"
                    render={() => (
                      <div className="logoWrapper">
                        <ImageField source="merchant.file" />
                        <TextField source="merchant.name" />
                      </div>
                    )}
                  />
                  <TextField
                    emptyText="No data"
                    source="type_enum"
                    label="Type enum"
                  />
                  <TextField
                    emptyText="No data"
                    source="country"
                    label="Country"
                  />
                  <TextField
                    emptyText="No data"
                    source="status_text"
                    label="Status text"
                  />
                  <TextField
                    emptyText="No data"
                    source="custom_status"
                    label="Custom status"
                  />
                  <TextFieldWithCopy
                    source="money_request_id"
                    label="Money request id"
                  />
                  <TextField
                    emptyText="No data"
                    source="amount_original"
                    label="Amount original"
                  />
                  <TextField
                    emptyText="No data"
                    source="currency_code_original"
                    label="Currency code original"
                  />
                  <DateField source="created_at" />
                  <DateField source="processed_at" />
                </SimpleShowLayout>
              </SimpleShowLayout>
            </Tab>

            <Tab label="Card tariff">
              <TextFieldWithCopy label="id" source="card_tariff.id" />
              <TextField label="Name" source="card_tariff.name" />
              <TextField label="Slug" source="card_tariff.slug" />
              <TextField
                label="Card count min"
                source="card_tariff.card_count_min"
              />
              <TextField
                label="Card count max"
                source="card_tariff.card_count_max"
              />
              <TextField label="Card price" source="card_tariff.card_price" />
              <TextField
                label="Replace price"
                source="card_tariff.replace_price"
              />
              <TextField
                label="Start balance"
                source="card_tariff.start_balance"
              />
              <TextField label="Duration" source="card_tariff.duration" />
              <TextField label="Type" source="card_tariff.type" />
              <TextField label="Fee topup" source="card_tariff.fee_topup" />
              <TextField
                label="Fee transaction amount"
                source="card_tariff.fee_transaction_amount"
              />
              <BooleanField
                label="Is visible"
                source="card_tariff.is_visible"
              />
              <BooleanField
                label="Is allowed for user"
                source="card_tariff.is_allowed_for_user"
              />
            </Tab>
            <Tab label="Subtrasactions">
              <FunctionField
                label="Subtrasactions"
                render={({ subtransactions }) => (
                  subtransactions.length && (
                  <DataGrid
                    disableColumnFilter
                    disableColumnMenu
                    hideFooter
                    rows={subtransactions}
                    columns={[...columns]}
                  />
                  )
                )}
              />
            </Tab>
          </TabbedShowLayout>
        </SimpleShowLayout>
      </RaShow>
    </>
  );
};
